import inqService from "@/stores/dataManager/apiServices/inqService"
import { ResponseSuccess } from "../followerTransManager/followerTransManager"
import ToastUtil from "@/views/components/Toast/Toast"
import datafeedService from "@/stores/dataManager/apiServices/datafeedService"
import { useAppSelector } from "@/stores/dataStore/reduxStore/hook"
import { T_ACTION_BY_SOCKET } from "@/stores/dataManager/Actions/appAction"
import i18next from 'i18next';
import localService from "@/stores/dataManager/localServices/localService"

export const useGetTheme = () => {
    try {
        const theme = useAppSelector((state) => state.app.theme)
        console.log('ha_check_useGetTheme', theme)
        return {
            theme
        };
    } catch (e) {
        console.log('ha_check_eeeee', e)
        return {
            theme: "dark",
        };
    }
}

export const useGetLanguage = () => {
    try {
        const language = useAppSelector((state) => state.app.language)
        console.log('ha_check_useGetLanguage', language)
        return {
            language
        };
    } catch (e) {
        console.log('ha_check_eeeee', e)
        return {
            language: "en",
        };
    }
}

export const useSaveVerify = () => {
    try {
        const saveVerify = useAppSelector((state) => state.app.saveVerify)
        return {
            saveVerify
        };
    } catch (e) {
        return {
            saveVerify: false,
        };
    }
}

export const getConfigCosManager = async () => {
    const param = {
        config: {},
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getConfigCos(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data?.[0] ?? {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getConfigCosManager'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getIndustrySymbol = async () => {
    const param = {
        config: {},
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await datafeedService.getIndustrySymbol(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getIndustrySymbol'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const useTradeAuthenticated = () => {
    try {
        const saveVerify = useAppSelector((state) => state.app.saveVerify)
        return {
            saveVerify
        };
    } catch (e) {
        return {
            saveVerify: null,
        };
    }
}

export const useGetStarted = () => {
    try {
        const started = useAppSelector((state) => state.app.started)
        return {
            started
        };
    } catch (e) {
        return {
            started: null,
        };
    }
}

export const useGetCosInfoStatus = () => {
    try {
        const setCosInfoStatus = useAppSelector((state) => state.app.setCosInfoStatus)
        return {
            setCosInfoStatus
        };
    } catch (e) {
        return {
            setCosInfoStatus: null,
        };
    }
}

export const useGetGlobalStateLoading = () => {
    try {
        const stateLoading = useAppSelector((state) => state.app.stateLoading)
        return {
            stateLoading
        };
    } catch (e) {
        return {
            stateLoading: null,
        };
    }
}

export const useGetSocketStatus = () => {
    try {
        const socketStatus = useAppSelector((state) => state.app.socketStatus)
        return {
            socketStatus
        };
    } catch (e) {
        return {
            socketStatus: null,
        };
    }
}

export const useGetStatusNotificationBySocket = () => {
    try {
        const statusNotificationBySocket = useAppSelector((state) => state.app.statusNotificationBySocket)
        return {
            statusNotificationBySocket
        };
    } catch (e) {
        return {
            statusNotificationBySocket: null,
        };
    }
}

export const useGetMgsNotificationBySocket = () => {
    try {
        const mgsNotificationBySocket = useAppSelector((state) => state.app.mgsNotificationBySocket) as (T_ACTION_BY_SOCKET | null)
        return {
            mgsNotificationBySocket
        };
    } catch (e) {
        return {
            mgsNotificationBySocket: null,
        };
    }
}


export const useGetFeatureSocketListener = () => {
    try {
        const featureSocketListener = useAppSelector((state) => state.app.featureSocketListener)
        return {
            featureSocketListener
        };
    } catch (e) {
        return {
            featureSocketListener: null,
        };
    }
}

export const useGetStatusRegisterMF = () => {
    try {
        const statusRegisterMF = useAppSelector((state) => state.app.statusRegisterMF) as (T_ACTION_BY_SOCKET | null)
        return {
            statusRegisterMF
        };
    } catch (e) {
        return {
            statusRegisterMF: null,
        };
    }
}

export const useGetMsgSocketRegister = () => {
    try {
        const msgSocketRegister = useAppSelector((state) => state.app.msgSocketRegister)
        return {
            msgSocketRegister
        };
    } catch (e) {
        return {
            msgSocketRegister: null,
        };
    }
}


export const useGetCosConfig = () => {
    try {
        const cosConfig = useAppSelector((state) => state.app.cosConfig)
        return {
            cosConfig
        };
    } catch (e) {
        return {
            cosConfig: {},
        };
    }
}

export const useGetIndustry = () => {
    try {
        const industry = useAppSelector((state) => state.app.industry)
        return {
            industry
        };
    } catch (e) {
        return {
            industry: [],
        };
    }
}

export type Type_CA = {
    caName: string,
    expire: string,
    Serial: string
}

export const getListCA = async () => {
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await localService.loadCAList().then((data: any) => {
        const rs = data.data;
        let listCA: Type_CA[] = [];
        if (rs.EC === 0) {
            let listCert = JSON.parse(data.DT);
            listCert.map((cert: any) => {
                let { Name, Serial } = cert,
                    caName = Name.substring(0, Name.indexOf("==[")),
                    expire = Name.substring(Name.indexOf("Expire") + 7, Name.length);
                listCA.push({
                    caName, expire, Serial
                });
            });
        }
        result = {
            isSuccess: true,
            data: listCA,
        }
    }).catch(error => {
        // ToastUtil.errorApi(error, i18next.t('msgApi.error.getIndustrySymbol'))
        result = {
            isSuccess: false,
        }
    })

    return result
}

export const submitSignData = async ({ serial, username, pin }: { serial: string | null, username: string, pin: string }) => {
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await localService.signData({ serial, username, pin }).then((data: any) => {
        const rs = data.data;
        let code = null
        if (rs.EC === 0) {
            code = rs.DT
        }

        result = {
            isSuccess: true,
            data: code,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('copytrade.auth.signfailed'))
        result = {
            isSuccess: false,
        }
    })

    return result
}